import React from "react";
import "./TeenPattiCards.css";
import { Modal } from "react-bootstrap";

function TeenPattiCards({ onHide, show, cardsHistory }) {
  const getCardName = (rank) => {
    const rankMap = {
      11: "J",
      12: "Q",
      13: "K",
      14: "A",
    };

    return rankMap[rank] || rank;
  };

  const getSuitSymbol = (suit) => {
    const suitMap = {
      H: "♥",
      D: "♦",
      C: "♣",
      S: "♠",
    };

    return suitMap[suit] || suit;
  };

  const parseCards = (name) => {
    try {
      return typeof name === "string"
        ? JSON.parse(name)
        : Array.isArray(name)
          ? name
          : [];
    } catch (error) {
      console.error("Invalid cards:", name);
      return [];
    }
  };

  const cards = parseCards(cardsHistory?.name);

  return (
    <div className="Successfull_Modal_sec">
      <Modal
        className="Successfull_Modal"
        size="lg"
        centered
        show={show}
        onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Player Cards</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="teen-patti-cards">
            {cards.length > 0 ? (
              cards.map((card, index) => (
                <div
                  key={index}
                  className={`teen-patti-card ${
                    card.suit === "H" || card.suit === "D"
                      ? "red-card"
                      : "black-card"
                  }`}>
                  <div className="card-rank">{getCardName(card.rank)}</div>

                  <div className="card-suit">{getSuitSymbol(card.suit)}</div>
                </div>
              ))
            ) : (
              <span>No cards found</span>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default TeenPattiCards;
